export const FileViews = {
  mobile: 'mobile',
  desktop: 'desktop',
  pdf: 'pdf',
};

export default FileViews;
